<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/overview-sale-list">
                    <icon name="file-alt"></icon>
                    ภาพรวมการขาย
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/transport-fee-report" v-if="!canViewPurchases || canViewSuperAdmin">
                    <icon name="file-alt"></icon>
                    รายงานค่าขนส่งของเซลล์
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/tax-driver-report" v-if="!canViewPurchases || canViewSuperAdmin">
                    <icon name="file-alt"></icon>
                    รายงานภาษี 1%
                </b-nav-item>&nbsp
                <b-nav-item router-link to="dashboard-selling" v-if="!canViewPurchases || canViewSuperAdmin">
                    <icon name="chart-area"></icon> รายงานการขาย (กราฟ)
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    import { canViewPurchases,canViewSuperAdmin } from "../../util/Permissions";

    export default {
        name: "overview-sale-layout",
        computed:{
            canViewPurchases,
            canViewSuperAdmin
        }
    }
</script>

<style scoped>

</style>
